export enum FundingType {
  Labor = "LABOR",
  Travel = "TRAVEL",
  Training = "TRAINING",
  Material = "MATERIAL",
  Fee = "FEE",
  ODC = "ODC",
  None = "NONE"
}